import { useMemo } from "react";
import "./App.css";
// import axios from "axios";
import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Routers } from "react-router-dom";
import AlertMessage from "./Components/AlertMessage/AlertMessage";
import Router from "./routes";
// import { AuthContext } from "./Context/AuthContext";
import { QueryClient, QueryClientProvider } from "react-query";

function App() {
  // const { state } = useContext(AuthContext);
  // const { user } = state;

  // ====================== set token =======================
  // useEffect(() => {
  //   let userToken = JSON.parse(window.localStorage.getItem("token"));
  //   if (userToken) {
  //     setToken(userToken);
  //     return;
  //   }

  //   if (user?.token) {
  //     setToken(user?.token);
  //     window.localStorage.setItem("token", JSON.stringify(user?.token));
  //   } else {
  //     setToken("")
  //   }
  // }, [user])

  //==================== CREATE THEME ========================
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          // mode: "light",
          background: {
            default: "#EBEDEF",
          },
        },
        typography: {
          // fontFamily: ["KantumruyPro", "Siemreap"].join(","),
          // fontFamily: ["Century Gothic"].join(","),
          fontFamily: ["KhmerOsSiemReap"].join(","),
        },
      }),
    [],
  );

  //================== Connect Apollo Client ===================
  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_END_POINT,
    // uri: "http://localhost:6360/graphql",
  });

  
  const authLink = setContext((_, { headers }) => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        ...headers,
        authorization: token,
      },
    };
  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    // link: ApolloLink.from([logoutLink, authLink, httpLink]),
    cache: new InMemoryCache(),
  });
  const queryClient = new QueryClient();

  return (
    <ApolloProvider client={client}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <Routers>
            <Router />
          </Routers>
          <CssBaseline />
        </ThemeProvider>
        <AlertMessage />
      </QueryClientProvider>
    </ApolloProvider>
  );
}

export default App;
